<template>
    <div>
        <comp-title-dc back-url-name="acctManager" :back-url-query="{ activeIndex: '2' }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager?activeIndex=2' }">
                    账户安全
                </el-breadcrumb-item>
                <el-breadcrumb-item>密码修改查询</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="info-box bizcomp-border">
            <div class="top-title">密码修改查询</div>
            <div>
                <div class="filter-box">
                    <div class="filter-block">
                        <span>操作日期：</span>
                        <date-picker
                            :date="dateSet"
                            sep-text="-"
                            style="width: 310px"
                            v-on:date-get="dateInterval"
                        />
                    </div>
                    <el-button
                        class="el-button--red"
                        size="small"
                        :disabled="isLoading"
                        v-on:click="queryPage()"
                    >
                        查询
                    </el-button>
                </div>
                <el-table
                    :data="dataObj.data"
                    class="tab-list-tit"
                    border
                    :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
                >
                    <template #empty>
                        <div class="no-funds">
                            <span class="no-funds-img" />
                            <div class="no-funds-box">
                                <p>暂无数据</p>
                            </div>
                        </div>
                    </template>
                    <el-table-column prop="opertime_date" label="操作日期" v-bind="tableColProps" />
                    <el-table-column prop="opertime_time" label="操作时间" v-bind="tableColProps" />
                    <el-table-column prop="event_optype" label="操作类型" v-bind="tableColProps" />
                    <el-table-column prop="event_pwdtype" label="密码类型" v-bind="tableColProps" />
                    <el-table-column prop="event_status" label="状态" v-bind="tableColProps" />
                </el-table>
                <el-pagination
                    v-if="dataObj.total > 0"
                    layout="->, total, prev, pager, next"
                    :total="dataObj.total"
                    :current-page.sync="dataObj.pageNum"
                    :page-size="dataObj.pageSize"
                    v-on:current-change="currentChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import datePicker from "@/components/form/datePicker";
import userApi from "@/api/user";
import format from "date-fns/format";
export default {
    name: "AcctInfoPwdModify",
    components: {
        datePicker
    },
    mixins: [mixin],
    data() {
        return {
            // 入参
            dateSet: {
                type: "2",
                min: "1990-01-01",
                size: "mini",
                text: "开始时间",
                text2: "结束时间"
            },
            endDate: "",
            beginDate: "",
            nowDate: "",
            // 表格
            tableColProps: {
                minWidth: "120",
                align: "center",
                headerAlign: "center",
                showOverflowTooltip: true,
                formatter: (row, column, value) => value || "--"
            },
            dataObj: {
                data: [],
                total: 0,
                pageNum: 1,
                pageSize: 10
            },
            isLoading: false
        };
    },
    mounted() {
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.queryPage();
    },
    methods: {
        // 获取用户选中时间区间
        dateInterval(val) {
            this.beginDate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        // 查询
        async queryPage() {
            this.isLoading = false;
            let list = [];
            let total = 0;
            try {
                let opertime = null;
                if (this.beginDate || this.endDate) {
                    const begin = this.beginDate ? this.beginDate + "000000" : "1970000000000";
                    const end = this.endDate ? this.endDate + "235959" : "99991231235959";
                    opertime = begin + "," + end;
                }
                const { data, code } = await userApi.qryAcctTracesLogList({
                    eventname: "密码操作留痕",
                    opertime: opertime,
                    pageSize: this.dataObj.pageSize,
                    pageNum: this.dataObj.pageNum
                });
                if (String(code) === "0") {
                    list = data.data.map((item) => {
                        let arr = [];
                        if (item.opertime.length === 14) {
                            arr = [item.opertime.substr(0, 8), item.opertime.substr(8, 6)];
                        } else {
                            arr = item.opertime ? item.opertime.split(" ") || [] : [];
                        }
                        let date = arr.length >= 1 ? arr[0].trim() : "";
                        date = date.length === 8 ? this.$util.fmtDate(date) : date;
                        let time = arr.length >= 2 ? arr[1].trim() : "";
                        time = time.length === 6 ? this.$util.fmtTime(time) : time;
                        const code = JSON.parse(item.content || "{}").code;
                        const res = {
                            opertime_date: date,
                            opertime_time: time
                        };
                        switch (item.eventid) {
                            case "/api/updateLoginPwd": {
                                res["event_optype"] = "修改密码";
                                res["event_pwdtype"] = "登录密码";
                                res["event_status"] =
                                    String(code) === "0" ? "修改成功" : "修改失败";
                                break;
                            }
                            case "/api/combLoginPasswordUpdate": {
                                res["event_optype"] = "修改密码";
                                res["event_pwdtype"] = "登录密码";
                                res["event_status"] =
                                    String(code) === "0" ? "修改成功" : "修改失败";
                                break;
                            }
                            case "/api/modifyPwd": {
                                res["event_optype"] = "修改密码";
                                res["event_pwdtype"] = "交易密码";
                                res["event_status"] =
                                    String(code) === "0" ? "修改成功" : "修改失败";
                                break;
                            }
                            case "/api/resetLoginPwd": {
                                res["event_optype"] = "找回密码";
                                res["event_pwdtype"] = "登录密码";
                                res["event_status"] =
                                    String(code) === "0" ? "找回成功" : "找回失败";
                                break;
                            }
                            case "/api/resettradepwd": {
                                res["event_optype"] = "找回密码";
                                res["event_pwdtype"] = "交易密码";
                                res["event_status"] =
                                    String(code) === "0" ? "找回成功" : "找回失败";
                                break;
                            }
                            default: {
                                res["event_status"] =
                                    String(code) === "0" ? "操作成功" : "操作失败";
                            }
                        }
                        return res;
                    });
                    total = data.total;
                }
            } catch (e) {
                console.error(e);
            }
            this.dataObj = {
                data: list,
                total: total,
                pageNum: this.dataObj.pageNum,
                pageSize: this.dataObj.pageSize
            };
            this.isLoading = false;
        },
        currentChange(val) {
            this.dataObj.pageNum = val;
            this.queryPage();
        }
    }
};
</script>

<style lang="scss" scoped>
.info-box {
    padding: 0 30px 30px;
    margin-bottom: 20px;
    margin-top: 13px;
    .top-title {
        color: var(--color-primary);
        font-size: 20px;
        padding: 16px 0;
        font-weight: 500;
    }
    .filter-box {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 16px 0;
        .filter-block {
            display: flex;
            align-items: center;
            gap: 8px;
            color: #333333;
        }
        .primary-btn {
            background-color: var(--color-primary);
            color: #ffffff;
            border-radius: 4px;
        }
        ::v-deep .el-input--mini .el-input__inner {
            height: 32px;
            line-height: 32px;
        }
    }
}
</style>
